<template>
  <div>
    <p class="font-md">This lists the notifications that require certification from parties on the notification.</p>
    <p class="font-md font-weight-bold">Any Pending notifications created over two years ago will be automatically deleted.</p>
    <PaginatedTable ref='pNTable'
      :fields="fields"
      :key="tableKey"
      :busy="isBusy"
      tableId="pendingNotificationsTable"
      noResultsText="You have no Pending Notifications."
      url="/notification/myPendingNotifications"
    >
      <template v-slot:head()="data">
        {{data.label}}
      </template>
      <template #table-busy>
        <LoadingSpinner  :message="`Loading Notifications`" />
      </template>
      <template v-slot:cell(townName)="data">
        <div class="mobile-row-center">
          {{data.item.townName}}
        </div>
      </template>
      <template v-slot:cell(statusName)="data">
        <div class="mobile-row-center">
          {{data.item.statusName}}
        </div>
      </template>
      <template v-slot:cell(operationDate)="data">
        <div class="mobile-row-center">
          {{data.item.operationStartDate | dateString}}
          -
          {{data.item.operationEndDate | dateString}}
        </div>
      </template>
      <template v-slot:cell(view)="data">
        <div
          class="text-lg-right mobile-row-around"
          :class="data.item.statusName === 'Draft' ? 'd-sm-block' : ''"
        >
          <router-link tag="a" size="sm" :to="`/notification/${data.item.id}`">
            View
          </router-link>
          <template v-if="data.item.statusName === 'Draft'">
            <span class="d-none d-md-inline-block">|</span>
            <b-link
              class="text-danger"
              @click="$bvModal.show(`fon-delete-confirm-${data.item.id}`)"
            >
              Delete
            </b-link>
          </template>
        </div>
        <b-modal
          :ref="`fon-delete-confirm-${data.item.id}`"
          :id="`fon-delete-confirm-${data.item.id}`"
          title="Delete FON"
          footer-class="text-center"
          centered
          hide-header-close
          size="sm"
        >
          <b-alert v-if="fonDeleteError" variant="danger" show>
            There was an error deleting this FON.
          </b-alert>
          You are attempting to delete this FON. This action cannot be undone.
          Are you sure you want to delete this FON?
          <div slot="modal-footer" class="d-flex full-width">
            <b-button
              pill
              variant="danger"
              class="mr-3"
              @click="$bvModal.hide(`fon-delete-confirm-${data.item.id}`)"
              aria-label="Cancel delete FON"
            >
              No
            </b-button>
            <b-button
              pill
              variant="primary"
              @click="deleteItem(data.item)"
              aria-label="Confirm delete FON"
            >
              Yes
            </b-button>
          </div>
        </b-modal>
      </template>
    </PaginatedTable>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PaginatedTable from '@/components/common/PaginatedTable.vue';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

export default {
  name: 'MyPendingNotifications',
  components: {
    PaginatedTable,
    LoadingSpinner,
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: 'townName', label: 'Town' },
        { key: 'statusName', label: 'Status' },
        { key: 'operationDate', label: 'Operation Start/End Date' },
        { key: 'view', label: '', stickyColumn: true },
      ],
      tableKey: 0,
    };
  },
  computed: {
    ...mapState(['isExtraSmall']),
    ...mapState('Notification', {
      fonDeleteError: state => state.fonDeleteError,
    }),
  },
  watch: {
    isExtraSmall() {
      if (this.isExtraSmall) {
        // move actionField in front of basic fields
        this.shiftMobile();
      } else {
        // move actionField to end of basic fields
        const actionField = this.fields.shift();
        this.fields.push(actionField);
      }
    },
  },
  methods: {
    shiftMobile() {
      const actionField = this.fields.pop();
      this.fields.unshift(actionField);
    },
    deleteItem(item) {
      this.$store.dispatch('Notification/deleteDraft', item.id).then(() => {
        this.forceRerender();
        this.$bvModal.hide(`fon-delete-confirm-${item.id}`);
      });
    },
    forceRerender() {
      this.tableKey += 1;
    },
  },
  created() {
    if (this.isExtraSmall) {
      // move actionField in front of basic fields
      this.shiftMobile();
    }
  },
};
</script>
